import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { CategorySidebar } from '../components/CategorySidebar';
import { MainContent } from '../components/MainContent';
import { LoginSidebar } from '../components/LoginSidebar';
export function HomePage() {
  return <div className="min-h-screen bg-gray-100" data-id="element-78">
      <Header data-id="element-79" />
      <Navigation data-id="element-80" />

      <div className="max-w-7xl mx-auto px-4 py-6" data-id="element-81">
        <div className="grid grid-cols-1 lg:grid-cols-[250px_1fr_300px] gap-4" data-id="element-82">
          <CategorySidebar data-id="element-83" />
          <MainContent data-id="element-84" />
          <LoginSidebar data-id="element-85" />
        </div>
      </div>
    </div>;
}